module.exports = __webpack_public_path__ + "static/media/13a-06_Tablas-&-camas-2013-273x176mm-oleo-sobre-revista-National-Geographic-y-madera.7c6f3e6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/13a/13a-06_Tablas-&-camas-2013-273x176mm-oleo-sobre-revista-National-Geographic-y-madera.png
// module id = 132
// module chunks = 0